import { FunctionComponent, useContext, useEffect, useState } from 'react';
import {
  DependencyAction,
  DependencyEffect,
  DependencyProps,
  DependencySourceType,
} from '../../../core/IDependency';
import { URIParameterContext } from '../../../core/contexte/URIParameterContext';
import {
  evaluateCondition,
  getUrlParameterValue,
} from './conditionalFieldUtils';
import { StaticConditionalFieldProps } from './types';

export const StaticConditionalField: FunctionComponent<
  StaticConditionalFieldProps
> = ({ children, rulesConfig, setParentVisible }) => {
  const [shouldRenderChildren, setShouldRenderChildren] =
    useState<boolean>(true);
  const { URIParameter } = useContext(URIParameterContext);

  const doAction = (action: DependencyAction) => {
    switch (action.effect) {
      case DependencyEffect.SHOW:
        setShouldRenderChildren(true);
        setParentVisible?.(true);
        return children;

      case DependencyEffect.HIDE:
        setShouldRenderChildren(false);
        setParentVisible?.(false);
        return null;

      default:
        setShouldRenderChildren(true);
        setParentVisible?.(true);
        return children;
    }
  };

  const handleRule = (config: DependencyProps) => {
    if (config.dependencySourceType !== DependencySourceType.URL_PARAMETER)
      return;

    const currentValueFromQueryString = getUrlParameterValue(
      URIParameter,
      config.superiorUrlParameterName
    );

    if (!currentValueFromQueryString) {
      doAction(config.actionNegative);
      return;
    }

    const shouldRenderChildren = evaluateCondition(
      config.condition,
      currentValueFromQueryString
    );
    shouldRenderChildren
      ? doAction(config.action)
      : doAction(config.actionNegative);
  };

  useEffect(() => {
    if (rulesConfig && rulesConfig.length > 0) {
      const config = rulesConfig[0];
      handleRule(config);
    }
  }, [rulesConfig, URIParameter]);

  if (!rulesConfig || rulesConfig.length < 1) return <>{children}</>;

  return shouldRenderChildren ? <>{children}</> : null;
};

export default StaticConditionalField;
